const audios = {};
export function loadAndPlayAudioInWx(param = {path:'res/audio/bg.mp3',autoplay:true}) {
    if(audios[param.path]) return audios[param.path];

    let audio = document.createElement("audio"); //this.$refs.audio; //e.target;//
    audio.src = param.path;
    audio.loop = true;
    audio.autoplay = param.autoplay;
    audio.preload = true;
    let playing = param.autoplay;
    if(playing) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          audio.play();
        },
        false
      );
    }
    
    document.addEventListener("visibilitychange", () => {
      if(!playing) return;
      if (document.hidden) {
        t = audio.currentTime;
        audio.pause();
      } else {
        // 原来在playing时，继续。。。
        setTimeout(() => {
          audio.play(t);
        }, 50);
      }
    });

    let t = 0;
    function pause() {
      if(!playing) return;
      t = audio.currentTime;
      audio.pause();
      playing = false;
    }
    function continuePlay()
    {
      if(playing) return;
      audio.play(t);
      playing = true;
    }
    function isPaused()
    {
      return !playing;
    }
    audios[param.path] = {pause, continuePlay, isPaused};
    return audios[param.path];
  }